(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/game-analyzes/assets/javascripts/game-analyzes-helpers.js') >= 0) return;  svs.modules.push('/components/sport/game-analyzes/assets/javascripts/game-analyzes-helpers.js'); 'use strict';

Handlebars.registerHelper('gameAnalysisAvatar', function (gameAnalysis, minImageWidth) {
  if (!gameAnalysis) {
    return '';
  }

  var authorProfile = gameAnalysis.authorProfile;

  if (!authorProfile) {
    return '';
  }

  var images = authorProfile.images;

  if (!Array.isArray(images) || images.length === 0) {
    return '';
  }

  var image = authorProfile.images[0];

  if (!image) {
    return '';
  }

  var availableWidths = image.availableWidths,
      url = image.url;

  if (!Array.isArray(availableWidths) || availableWidths.length === 0) {
    return '';
  }

  var currentImageWidth = Number.MAX_VALUE;
  availableWidths.forEach(function (width) {
    if (width < currentImageWidth && width >= minImageWidth) {
      currentImageWidth = width;
    }
  });
  var imageUrl = url.replace('{width}', currentImageWidth);
  return "".concat(svs.core.config.data.svsconfig.cdn2).concat(imageUrl);
});
 })(window);